<header class="topbar">

  <div>

    <span class="topbar-label">
      Gerenciamento
    </span>

    <h1>
      Reservas
    </h1>

    <p>
      Consulte as reservas e gerencie os cancelamentos.
    </p>

  </div>

</header>


<div class="reservas-busca">

  <div class="campo-busca">

    <svg
      class="icone-busca"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >

      <path
        d="M21 21L16.65 16.65M19 11C19 15.4183 15.4183 19 11 19C6.58172 19 3 15.4183 3 11C3 6.58172 6.58172 3 11 3C6.58172 3 11 3 11 3"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />

    </svg>


    <input
      type="text"
      placeholder="Buscar por número da reserva, CPF ou nome..."
      [(ngModel)]="termoBusca"
      (keyup.enter)="buscarReservas()"
    />


    <button
      type="button"
      class="btn-buscar"
      (click)="buscarReservas()"
    >
      Buscar
    </button>


    <!-- FILTRO -->

    <select
      class="filtro-status"
      [(ngModel)]="statusFiltro"
      (change)="alterarFiltroStatus()"
    >

      <option
        *ngFor="let filtro of statusFiltros"
        [value]="filtro.valor"
      >
        {{ filtro.label }}
      </option>

    </select>


    <!-- FILTRO DE ORDENAÇÃO -->
    <select
      class="filtro-status"
      [(ngModel)]="ordenacaoFiltro"
      (change)="alterarOrdenacao()"
    >
      <option value="RECENTES">
        Mais recentes primeiro
      </option>

      <option value="ANTIGAS">
        Mais antigas primeiro
      </option>
    </select>



    <!-- LIMPAR -->

    <button
      type="button"
      class="btn-limpar"
      *ngIf="
  termoBusca
  || statusFiltro !== 'TODOS'
  || ordenacaoFiltro !== 'RECENTES'
"
      (click)="limparBusca()"
    >
      Limpar
    </button>

  </div>

</div>


<section class="reservas-section">


  <!-- LOADING -->

  <div
    class="loading"
    *ngIf="carregando"
  >
    Carregando reservas...
  </div>


  <!-- ERRO -->

  <div
    class="erro"
    *ngIf="!carregando && erro"
  >
    {{ erro }}
  </div>


  <!-- RESERVAS -->

  <div
    class="reservas-lista"
    *ngIf="
      !carregando
      && !erro
      && reservas.length > 0
    "
  >


    <article
      class="reserva-card"
      *ngFor="let reserva of reservas"
    >


      <!-- ========================= -->
      <!-- CABEÇALHO -->
      <!-- ========================= -->

      <div class="reserva-cabecalho">


        <div class="reserva-identificacao">

          <span class="reserva-label">
            Data que realizou a reserva
            {{ reserva.criadoEm | date:'dd/MM/yyyy' }}
            às
            {{ reserva.criadoEm | date:'HH:mm' }}
          </span>


          <h2>
            RESERVA #{{ reserva.id }}
          </h2>


          <p>
            {{ reserva.quartoNome }}
          </p>

        </div>


        <div class="reserva-cabecalho-direita">


          <span
            class="status"

            [class.confirmada]="
              reserva.status === 'CONFIRMADA'
            "

            [class.paga]="
              reserva.status === 'PAGA'
            "

            [class.cancelada]="
              reserva.status === 'CANCELADA'
            "

            [class.pendente]="
              reserva.status === 'AGUARDANDO_PAGAMENTO'
            "

            [class.expirada]="
              reserva.status === 'EXPIRADA'
            "

            [class.finalizada]="
              reserva.status === 'FINALIZADA'
            "
          >
            {{ getStatusLabel(reserva.status) }}
          </span>


        </div>

      </div>


      <!-- ========================= -->
      <!-- INFORMAÇÕES PRINCIPAIS -->
      <!-- ========================= -->

      <div class="reserva-informacoes">


        <!-- HÓSPEDE -->

        <div class="informacao">

          <span>
            Hóspede responsável
          </span>

          <strong
            *ngIf="
              reserva.hospedes
              && reserva.hospedes.length > 0
            "
          >
            {{ reserva.hospedes[0].nome }}
            {{ reserva.hospedes[0].sobrenome }}
          </strong>

          <strong
            *ngIf="
              !reserva.hospedes
              || reserva.hospedes.length === 0
            "
          >
            -
          </strong>

        </div>


        <!-- TELEFONE -->

        <div class="informacao">

          <span>
            Telefone
          </span>

          <strong>
            {{ getTelefonePrincipal(reserva) }}
          </strong>

        </div>


        <!-- CHECK-IN -->

        <div class="informacao">

          <span>
            Check-in
          </span>

          <strong>
            {{ formatarData(reserva.checkIn) }}
          </strong>

        </div>


        <!-- CHECK-OUT -->

        <div class="informacao">

          <span>
            Check-out
          </span>

          <strong>
            {{ formatarData(reserva.checkOut) }}
          </strong>

        </div>


        <!-- NOITES -->

        <div class="informacao">

          <span>
            Noites
          </span>

          <strong>
            {{ reserva.quantidadeNoites }}
          </strong>

        </div>


      </div>


      <!-- ========================= -->
      <!-- HÓSPEDES / CRIANÇAS / ANIMAIS -->
      <!-- ========================= -->

      <div class="reserva-composicao">


        <div class="composicao-item">

          <span>
            Hóspedes
          </span>

          <strong>
            {{ reserva.quantidadeHospedes }}
          </strong>

        </div>


        <div
          class="composicao-item"
          *ngIf="
            (reserva.quantidadeCriancas ?? 0) > 0
          "
        >

          <span>
            Crianças
          </span>

          <strong>
            {{ reserva.quantidadeCriancas }}
          </strong>

        </div>


        <div
          class="composicao-item"
          *ngIf="
            (reserva.quantidadeAnimais ?? 0) > 0
          "
        >

          <span>
            Animais
          </span>

          <strong>
            {{ reserva.quantidadeAnimais }}
          </strong>

        </div>


      </div>


      <!-- ========================= -->
      <!-- CONTRATAÇÃO -->
      <!-- ========================= -->

      <div class="contratacao">


        <div class="contratacao-cabecalho">

          <span>
            Contratação
          </span>

          <strong
            *ngIf="
              !reserva.pacotes
              || reserva.pacotes.length === 0
            "
          >
            Hospedagem
          </strong>

          <strong
            *ngIf="
              reserva.pacotes
              && reserva.pacotes.length > 0
            "
          >
            Hospedagem + pacote
            <span
              *ngIf="reserva.pacotes.length > 1"
            >
              s
            </span>
          </strong>

        </div>


        <!-- SEM PACOTE -->

        <div
          class="contratacao-hospedagem"
          *ngIf="
            !reserva.pacotes
            || reserva.pacotes.length === 0
          "
        >

          <span class="contratacao-item">
            Hospedagem
          </span>

        </div>


        <!-- COM PACOTE -->

        <div
          class="pacotes-lista"
          *ngIf="
            reserva.pacotes
            && reserva.pacotes.length > 0
          "
        >

          <div
            class="pacote-item"
            *ngFor="let pacote of reserva.pacotes"
          >

            <span class="pacote-nome">
              {{ pacote.nome }}
            </span>

            <strong class="pacote-valor">
              {{ formatarMoeda(pacote.valor) }}
            </strong>

          </div>

        </div>


      </div>


      <!-- ========================= -->
      <!-- RODAPÉ / VALOR -->
      <!-- ========================= -->

      <div class="reserva-rodape">


        <div class="reserva-valor">

          <span>Valor total</span>

          <strong>
            {{ formatarMoeda(reserva.valorTotal) }}
          </strong>

          <!-- EXIBE SOMENTE SE UTILIZOU CUPOM -->
          <div
            class="reserva-cupom"
            *ngIf="reserva.codigoCupom"
          >
            <span class="reserva-cupom-label">
              Cupom utilizado:
            </span>

            <strong class="reserva-cupom-codigo">
              {{ reserva.codigoCupom }}
            </strong>
          </div>

        </div>


        <div class="reserva-acoes">

          <button
            type="button"
            class="btn-invoice"
            *ngIf="obterInvoiceUrl(reserva)"
            (click)="abrirInvoice(reserva)"
          >
            Ver invoice
          </button>


          <button
            type="button"
            class="btn-cancelar-reserva"

            *ngIf="
              podeCancelar(reserva)
            "

            [disabled]="
              cancelandoId === reserva.id
            "

            (click)="
              cancelarReserva(reserva)
            "
          >

            {{
              cancelandoId === reserva.id
                ? 'Cancelando...'
                : 'Cancelar reserva'
            }}

          </button>

          <button
            *ngIf="
              reserva.status === 'AGUARDANDO_PAGAMENTO'
              && !obterInvoiceUrl(reserva)
            "
            type="button"
            class="btn-invoice"
            [disabled]="gerandoLinkId !== null"
            (click)="gerarLinkPagamento(reserva)">

            {{
              gerandoLinkId === reserva.id
                ? 'Gerando link...'
                : 'Gerar link de pagamento'
            }}
          </button>

          <button
            type="button"
            class="btn-editar-datas"
            *ngIf="podeEditarDatas(reserva)"
            [disabled]="salvandoDatasId === reserva.id"
            (click)="abrirModalEditarDatas(reserva)"
          >
            {{
              salvandoDatasId === reserva.id
                ? 'Salvando...'
                : 'Editar datas'
            }}
          </button>


          <span
            class="sem-acao"

            *ngIf="
              !podeCancelar(reserva)
              && reserva.status === 'CONFIRMADA'
            "
          >
            Cancelamento indisponível
          </span>


          <span
            class="cancelada-label"

            *ngIf="
              reserva.status === 'CANCELADA'
            "
          >
            Reserva cancelada
          </span>


        </div>


      </div>


    </article>

  </div>


  <!-- NENHUMA RESERVA -->

  <div
    class="loading"
    *ngIf="
      !carregando
      && !erro
      && reservas.length === 0
    "
  >
    Nenhuma reserva encontrada.
  </div>



</section>


<!-- MODAL EDITAR DATAS -->
<div
  class="modal-datas-overlay"
  *ngIf="modalEditarDatasAberto && reservaEmEdicao"
  (click)="fecharModalEditarDatas()"
>
  <div
    class="modal-datas"
    role="dialog"
    aria-modal="true"
    aria-labelledby="titulo-modal-datas"
    (click)="$event.stopPropagation()"
  >
    <div class="modal-datas-cabecalho">
      <div>
        <span class="modal-datas-etiqueta">
          GERENCIAMENTO DE RESERVAS
        </span>
        <h2 id="titulo-modal-datas">Editar datas</h2>
        <p>Reserva #{{ reservaEmEdicao.id }}</p>
      </div>

      <button
        type="button"
        class="modal-datas-fechar"
        aria-label="Fechar modal"
        [disabled]="salvandoDatasId !== null"
        (click)="fecharModalEditarDatas()"
      >
        &times;
      </button>
    </div>

    <div class="modal-datas-conteudo">
      <div class="modal-datas-acomodacao">
        <span>Acomodação</span>
        <strong>{{ reservaEmEdicao.quartoNome }}</strong>
      </div>

      <div class="modal-datas-periodo">
        <span>Período atual</span>
        <strong>
          {{ formatarData(reservaEmEdicao.checkIn) }}
          —
          {{ formatarData(reservaEmEdicao.checkOut) }}
        </strong>
      </div>

      <div class="modal-datas-campos">
        <div class="modal-datas-campo">
          <label for="editar-checkin">Novo check-in</label>
          <input
            id="editar-checkin"
            type="date"
            [(ngModel)]="novaDataCheckIn"
            [disabled]="salvandoDatasId !== null"
          />
        </div>

        <div class="modal-datas-campo">
          <label for="editar-checkout">Novo check-out</label>
          <input
            id="editar-checkout"
            type="date"
            [(ngModel)]="novaDataCheckOut"
            [min]="novaDataCheckIn"
            [disabled]="salvandoDatasId !== null"
          />
        </div>
      </div>

      <div class="modal-datas-aviso">
        Somente as datas serão alteradas.
        O valor da reserva, o status e as informações
        de pagamento permanecerão inalterados.
      </div>
    </div>

    <div class="modal-datas-acoes">
      <button
        type="button"
        class="modal-datas-cancelar"
        [disabled]="salvandoDatasId !== null"
        (click)="fecharModalEditarDatas()"
      >
        Voltar
      </button>

      <button
        type="button"
        class="modal-datas-salvar"
        [disabled]="
          salvandoDatasId !== null ||
          !novaDataCheckIn ||
          !novaDataCheckOut ||
          novaDataCheckOut <= novaDataCheckIn
        "
        (click)="confirmarEdicaoDatas()"
      >
        {{
          salvandoDatasId !== null
            ? 'Salvando...'
            : 'Salvar alterações'
        }}
      </button>
    </div>
  </div>
</div>

